import React from 'react';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseVpnCommunity from '../../AbstractObjects/GatewayPlan/InnerPages/BaseVpnCommunity';

const pageSchema = PlanGetSchema.pages.vpnCommunity;
const pageId = pageSchema.pageId;

function PlanVpnCommunity({
    planObject,
    setPlanData
}) {

    const pageData = planObject[pageId];
    
    return (
        <BaseVpnCommunity
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );

}

export default PlanVpnCommunity;